import updatePassword from './update-password';

export default {
  ...updatePassword,
};
